import AssignedTaskList from './assigned_task_list';

export default AssignedTaskList;
